import { useRef } from "react";
import { useParams } from "react-router";
import { DashboardUtils } from "../../../dashboard_utils";
import { useGuildMemberQuery } from "../hooks/use_guild_members";
import { WithTooltip } from "../tooltips/with_tooltip";

export default function AnonymousNameWithAvatar() {
	// Create a random integer between 0 and 4
	const random = useRef(Math.floor(Math.random() * 5));

	return (
		<>
			<span className="mr-1 inline-block align-text-bottom">
				<figure className="image is-24x24 flex-shrink-0">
					<img
						className="is-rounded"
						src={DashboardUtils.GetPlaceholderAvatarURL(
							random.current.toString(),
							32
						)}
						width={24}
						height={24}
					/>
				</figure>
			</span>
			Anonymous
		</>
	);
}
